<template>
  <el-dialog
    title="删除确认"
    :visible.sync="dialogVisible"
    width="30%"
    @close="resetData"
  >
    <div style="text-align: center;">
      <p>确定删除打印配置？</p>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">点错了</el-button>
      <el-button type="primary" @click="confirmDelete">确认删除</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { deleteFeePrintSpec } from '@/api/goods/feePrintSpecApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'DeleteFeePrintSpec',
  data() {
    return {
      dialogVisible: false,
      deleteData: {
        printId: '',
        shopId: ''
      }
    }
  },
  methods: {
    open(data) {
      this.deleteData = {
        printId: data.printId,
        shopId: getShopId()
      }
      this.dialogVisible = true
    },
    async confirmDelete() {
      try {
        await deleteFeePrintSpec(this.deleteData)
        this.$message.success('删除成功')
        this.dialogVisible = false
        this.$emit('refresh')
      } catch (error) {
        console.error(error)
        this.$message.error(error.message || '删除失败')
      }
    },
    resetData() {
      this.deleteData = {
        printId: '',
        shopId: ''
      }
    }
  }
}
</script>